/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { investmentNeedAllocationBreakdownDtoSchema } from "./investmentNeedAllocationBreakdownDtoSchema.ts";
import { z } from "zod/v4";

export const investmentNeedAllocationCategoryDtoSchema = z.object({
  category: z.optional(z.string()),
  amount: z.optional(z.string()),
  share: z.optional(z.int()),
  swatchIndex: z.optional(z.int()),
  get breakdown() {
    return z.array(investmentNeedAllocationBreakdownDtoSchema).optional();
  },
});
